/* eslint-disable max-lines */

import { storagePrefix, storagePrefixFixedV2 } from '@/constant';

const CommonBackImg = storagePrefixFixedV2 + '/model-texture/common-back.png';

// 全背按摩方案贴图配置
export const FullMassageBgConfig = {
  left: {
    imageConfig: {
      url: CommonBackImg,
      size: [140, 645],
    },
    coord: [410, 330],
  },
  right: {
    imageConfig: {
      url: CommonBackImg,
      size: [140, 645],
    },
    coord: [540, 330],
  },
};

// 全背按摩16点位方案贴图配置
export const FullMassageBgConfigWith16Point = {
  left: {
    imageConfig: {
      url: CommonBackImg,
      size: [140, 590],
    },
    coord: [410, 340],
  },
  right: {
    imageConfig: {
      url: CommonBackImg,
      size: [140, 590],
    },
    coord: [540, 340],
  },
};

// 翟老师按摩方案贴图配置
export const MassageZhaiBgConfig = {
  left: {
    imageConfig: {
      url: CommonBackImg,
      size: [130, 539],
    },
    coord: [420, 390],
  },
  right: {
    imageConfig: {
      url: CommonBackImg,
      size: [130, 539],
    },
    coord: [540, 390],
  },
};

// 肩部按摩方案配置
export const ShoulderMassageBgConfig = {
  left: {
    imageConfig: {
      url: storagePrefixFixedV2 + '/model-texture/massage-common-bg-left.png',
      size: [150, 310],
    },
    coord: [410, 445],
  },
  right: {
    imageConfig: {
      url: storagePrefixFixedV2 + '/model-texture/massage-common-bg-right.png',
      size: [150, 310],
    },
    coord: [534, 445],
  },
};

// 肩部吕教授按摩方案配置
export const ShouldeLvMassageBgConfig = {
  left: {
    imageConfig: {
      url: CommonBackImg,
      size: [130, 220],
    },
    coord: [419, 452],
  },
  right: {
    imageConfig: {
      url: CommonBackImg,
      size: [130, 220],
    },
    coord: [542, 452],
  },
};

// 肩部吕教授第二步骤按摩方案配置
export const ShouldeLvMassageStep2BgConfig = {
  left: {
    imageConfig: {
      url: CommonBackImg,
      size: [130, 220],
    },
    coord: [419, 452],
  },
  right: {
    imageConfig: {
      url: CommonBackImg,
      size: [130, 220],
    },
    coord: [542, 452],
  },
};

// 肩部吕教授按摩方案V2版本配置
export const ShouldeLvMassageBgConfigV2 = {
  left: {
    imageConfig: {
      url: CommonBackImg,
      size: [130, 350],
    },
    coord: [419, 452],
  },
  right: {
    imageConfig: {
      url: CommonBackImg,
      size: [130, 350],
    },
    coord: [542, 452],
  },
};

// 肩部吕教授按摩方案V2版本配置
export const ShouldeLvMassageBgConfigV2Optimize = {
  left: {
    imageConfig: {
      url: CommonBackImg,
      size: [130, 210],
    },
    coord: [419, 350],
  },
  right: {
    imageConfig: {
      url: CommonBackImg,
      size: [130, 210],
    },
    coord: [542, 350],
  },
};

// 肩部吕教授按摩方案V2版本配置
export const WaistLvMassageBg = {
  left: {
    imageConfig: {
      url: CommonBackImg,
      size: [130, 175],
    },
    coord: [410, 740],
  },
  right: {
    imageConfig: {
      url: CommonBackImg,
      size: [130, 175],
    },
    coord: [542, 740],
  },
};

export const WaistLvMassageBgStep2 = {
  left: {
    imageConfig: {
      url: CommonBackImg,
      size: [130, 210],
    },
    coord: [410, 710],
  },
  right: {
    imageConfig: {
      url: CommonBackImg,
      size: [130, 210],
    },
    coord: [542, 710],
  },
};

// 腰部按摩方案配置
export const WaistMassageBgConfig = {
  left: {
    imageConfig: {
      url: CommonBackImg,
      size: [150, 310],
    },
    coord: [410, 740],
  },
  right: {
    imageConfig: {
      url: CommonBackImg,
      size: [150, 310],
    },
    coord: [534, 740],
  },
};

export const AnimationArrowConfig = {
  full: {
    left: { coord: [445, 390], offsetY: 220 },
    right: { coord: [576, 390], offsetY: 220 },
  },
  massageWith16Points: {
    left: { coord: [445, 390], offsetY: 210 },
    right: { coord: [576, 390], offsetY: 210 },
  },
  zhaiTeacher: {
    left: { coord: [453, 440], offsetY: 190 },
    right: { coord: [576, 440], offsetY: 190 },
  },
  shoulder: {
    left: { coord: [440, 455], offsetY: 80 },
    right: { coord: [570, 455], offsetY: 80 },
  },
  lvShoulder: {
    left: { coord: [453, 465], offsetY: 40 },
    right: { coord: [575, 465], offsetY: 40 },
  },
  lvShoulderV2: {
    left: { coord: [453, 465], offsetY: 90 },
    right: { coord: [575, 465], offsetY: 90 },
  },
  lvShoulderV2Optimize: {
    left: { coord: [453, 360], offsetY: 40 },
    right: { coord: [575, 360], offsetY: 40 },
  },
  lvWaist: {
    left: { coord: [445, 750], offsetY: 20 },
    right: { coord: [570, 750], offsetY: 20 },
  },
  lvShoulderStep2: {
    left: { coord: [453, 465], offsetY: 40 },
    right: { coord: [575, 465], offsetY: 40 },
  },
  waist: {
    left: { coord: [450, 760], offsetY: 70 },
    right: { coord: [580, 760], offsetY: 70 },
  },
};

// 按摩点大小
export const MassagePointSize = [25, 25];
// 动态点绘制偏移量
export const MassageActivePointOffetSize = 12;

// 全背按摩点的坐标信息
export const FullMassagePointConfig = [
  {
    coord: [483, 368],
  },
  {
    coord: [483, 428],
  },
  {
    coord: [483, 522],
  },
  {
    coord: [483, 590],
  },
  {
    coord: [483, 668],
  },
  {
    coord: [483, 725],
  },
  {
    coord: [483, 793],
  },
  {
    coord: [483, 878],
  },
  {
    coord: [483, 918],
  },
  {
    coord: [581, 368],
  },
  {
    coord: [581, 428],
  },
  {
    coord: [581, 522],
  },
  {
    coord: [581, 590],
  },
  {
    coord: [581, 668],
  },
  {
    coord: [581, 725],
  },
  {
    coord: [581, 793],
  },
  {
    coord: [581, 878],
  },
  {
    coord: [581, 918],
  },
];
// 全背按摩点坐标信息（10点）
export const FullMassagePointConfigWith10Point = [
  {
    coord: [483, 368],
  },
  {
    coord: [483, 522],
  },
  {
    coord: [483, 668],
  },
  {
    coord: [483, 793],
  },
  {
    coord: [483, 918],
  },
  {
    coord: [581, 368],
  },
  {
    coord: [581, 522],
  },
  {
    coord: [581, 668],
  },
  {
    coord: [581, 793],
  },
  {
    coord: [581, 918],
  },
];
// 16点位按摩点区域坐标
export const FullMassageWith16PointConfig = [
  {
    coord: [480, 500],
  },
  {
    coord: [480, 572],
  },
  {
    coord: [480, 644],
  },
  {
    coord: [480, 716],
  },
  {
    coord: [480, 788],
  },
  {
    coord: [480, 860],
  },
  {
    coord: [480, 930],
  },
  {
    coord: [480, 980],
  },
  {
    coord: [535, 500],
  },
  {
    coord: [535, 572],
  },
  {
    coord: [535, 644],
  },
  {
    coord: [535, 716],
  },
  {
    coord: [535, 788],
  },
  {
    coord: [535, 860],
  },
  {
    coord: [535, 930],
  },
  {
    coord: [535, 980],
  },
];

// 翟老师按摩点配置
export const MassageZhaiPointsConfig = [
  {
    coord: [483, 428],
  },
  {
    coord: [483, 522],
  },
  {
    coord: [483, 590],
  },
  {
    coord: [483, 668],
  },
  {
    coord: [483, 706],
  },
  {
    coord: [483, 725],
  },
  {
    coord: [483, 793],
  },
  {
    coord: [483, 878],
  },
  {
    coord: [581, 428],
  },
  {
    coord: [581, 522],
  },
  {
    coord: [581, 590],
  },
  {
    coord: [581, 668],
  },
  {
    coord: [581, 706],
  },
  {
    coord: [581, 725],
  },
  {
    coord: [581, 793],
  },
  {
    coord: [581, 878],
  },
];

export const ZhaiTeacherRoutePoints = [
  {
    coord: [483, 368],
  },
  {
    coord: [483, 878],
  },
  {
    coord: [581, 368],
  },
  {
    coord: [581, 878],
  },
];

// 肩部按摩点的坐标信息
export const ShoulderMassagePointConfig = [
  {
    coord: [480, 430],
  },
  {
    coord: [535, 430],
  },
  {
    coord: [480, 695],
  },
  {
    coord: [535, 695],
  },
];

// 肩部吕教授方案按摩点的坐标信息
export const ShoulderLvMassagePointConfig = [
  {
    coord: [418, 450],
  },
  {
    coord: [475, 450],
  },
  {
    coord: [418, 570],
  },
  {
    coord: [475, 520],
  },
  {
    coord: [600, 450],
  },
  {
    coord: [545, 450],
  },
  {
    coord: [600, 570],
  },
  {
    coord: [545, 520],
  },
];

// 肩部吕教授方案步骤2按摩点的坐标信息
export const ShoulderLvStep2MassagePointConfig = [
  {
    coord: [475, 446],
  },
  {
    coord: [475, 610],
  },
  {
    coord: [545, 446],
  },
  {
    coord: [545, 610],
  },
];

// 肩部吕教授方案V2版本按摩点的坐标信息
export const ShoulderLvMassagePointConfigV2 = [
  {
    coord: [475, 446],
  },
  {
    coord: [475, 482],
  },
  {
    coord: [475, 518],
  },
  {
    coord: [475, 554],
  },
  {
    coord: [475, 590],
  },
  {
    coord: [475, 626],
  },
  {
    coord: [475, 660],
  },
  {
    coord: [475, 730],
  },
  {
    coord: [545, 446],
  },
  {
    coord: [545, 482],
  },
  {
    coord: [545, 518],
  },
  {
    coord: [545, 554],
  },
  {
    coord: [545, 590],
  },
  {
    coord: [545, 626],
  },
  {
    coord: [545, 660],
  },
  {
    coord: [545, 730],
  },
];

// 肩部吕教授方案V2版本按摩点的坐标信息
export const ShoulderLvMassagePointConfigV2Optimize = [
  {
    coord: [483, 368],
  },
  {
    coord: [483, 396],
  },
  {
    coord: [483, 428],
  },
  {
    coord: [483, 522],
  },
  {
    coord: [581, 368],
  },
  {
    coord: [581, 396],
  },
  {
    coord: [581, 428],
  },
  {
    coord: [581, 522],
  },
];

// 肩部吕教授方案V2版本走线时按摩点的坐标信息
export const ShoulderLvMassagePointConfigV2OptimizeRoute = [
  {
    coord: [483, 368],
  },
  {
    coord: [483, 522],
  },
  {
    coord: [581, 368],
  },
  {
    coord: [581, 522],
  },
];

// 腰部吕教授方案按摩点的坐标信息
export const WaistLvMassagePointConfig = [
  {
    coord: [483, 760],
  },
  {
    coord: [483, 793],
  },
  {
    coord: [483, 833],
  },
  {
    coord: [483, 878],
  },
  {
    coord: [581, 760],
  },
  {
    coord: [581, 793],
  },
  {
    coord: [581, 833],
  },
  {
    coord: [581, 878],
  },
];

// 腰部部吕教授方案走线时按摩点的坐标信息
export const WaistLvMassagePointRouteConfig = [
  {
    coord: [483, 725],
  },
  {
    coord: [483, 878],
  },
  {
    coord: [581, 725],
  },
  {
    coord: [581, 878],
  },
];

// 腰部按摩点的坐标信息
export const WaistMassagePointConfig = [
  {
    coord: [490, 740],
  },
  {
    coord: [546, 740],
  },
  {
    coord: [480, 985],
  },
  {
    coord: [540, 985],
  },
];

// 应该升级为动态渲染方案的solution集合
export const shouldUpgradeModelSolutions: (Massage.ModelSolution | Massage.DynamicSolution)[] = [
  'neck-RF',
  'shoulder-RF',
  'waist-RF',
  'abdomen-RF',
  'back-RF',
  'matrix-moxibustion',
  'matrix-moxibustion-abdomen',
  'massage-yzc',
  'waist-massage-yzc',
  'massage-yzc-zhai-dynamic',
  'massage-shoulder-lv-dynamic',
  'massage-waist-lv-dynamic',
  'massage-yzc-10-points',
];

export const lvWaistMassageActionId2Times = [
  {
    actionId: 9,
    leftTimes: 0,
    rightTimes: 0,
  },
  {
    actionId: 10,
    leftTimes: 1,
    rightTimes: 0,
  },
  {
    actionId: 11,
    leftTimes: 1,
    rightTimes: 1,
  },
  {
    actionId: 12,
    leftTimes: 2,
    rightTimes: 1,
  },
  {
    actionId: 13,
    leftTimes: 2,
    rightTimes: 2,
  },
  {
    actionId: 14,
    leftTimes: 1,
    rightTimes: 0,
  },
  {
    actionId: 15,
    leftTimes: 1,
    rightTimes: 1,
  },
  {
    actionId: 16,
    leftTimes: 2,
    rightTimes: 1,
  },
];

export const lvShoulderMassageV2ActionId2Times = lvWaistMassageActionId2Times;

export const ZhaiActionId2Times = [
  {
    actionId: 17,
    isLeft: true,
    leftTimes: 0,
    rightTimes: 0,
  },
  {
    actionId: 18,
    isLeft: true,
    leftTimes: 1,
    rightTimes: 0,
  },
  {
    actionId: 19,
    isLeft: true,
    leftTimes: 2,
    rightTimes: 0,
  },
  {
    actionId: 20,
    isLeft: false,
    leftTimes: 3,
    rightTimes: 0,
  },
  {
    actionId: 21,
    isLeft: false,
    leftTimes: 3,
    rightTimes: 1,
  },
  {
    actionId: 22,
    isLeft: false,
    leftTimes: 3,
    rightTimes: 2,
  },
  {
    actionId: 23,
    isLeft: true,
    leftTimes: 3,
    rightTimes: 3,
  },
  {
    actionId: 24,
    isLeft: true,
    leftTimes: 1,
    rightTimes: 0,
  },
  {
    actionId: 25,
    isLeft: true,
    leftTimes: 2,
    rightTimes: 0,
  },
  {
    actionId: 26,
    isLeft: false,
    leftTimes: 3,
    rightTimes: 0,
  },
  {
    actionId: 27,
    isLeft: false,
    leftTimes: 3,
    rightTimes: 1,
  },
  {
    actionId: 28,
    isLeft: false,
    leftTimes: 3,
    rightTimes: 2,
  },
];

export const WaistActionId2Times = [
  {
    actionId: 1,
    isLeft: true,
    leftTimes: 0,
    rightTimes: 0,
  },
  {
    actionId: 2,
    isLeft: false,
    leftTimes: 1,
    rightTimes: 0,
  },
  {
    actionId: 3,
    isLeft: true,
    leftTimes: 1,
    rightTimes: 1,
  },
  {
    actionId: 4,
    isLeft: false,
    leftTimes: 2,
    rightTimes: 1,
  },
  {
    actionId: 5,
    isLeft: true,
    leftTimes: 2,
    rightTimes: 2,
  },
  {
    actionId: 6,
    isLeft: false,
    leftTimes: 3,
    rightTimes: 2,
  },
  {
    actionId: 7,
    isLeft: true,
    leftTimes: 3,
    rightTimes: 3,
  },
  {
    actionId: 8,
    isLeft: false,
    leftTimes: 4,
    rightTimes: 3,
  },
  {
    actionId: 9,
    isLeft: true,
    leftTimes: 4,
    rightTimes: 4,
  },
  {
    actionId: 10,
    isLeft: false,
    leftTimes: 5,
    rightTimes: 4,
  },
  {
    actionId: 11,
    isLeft: true,
    leftTimes: 5,
    rightTimes: 5,
  },
  {
    actionId: 12,
    isLeft: false,
    leftTimes: 6,
    rightTimes: 5,
  },
  {
    actionId: 13,
    isLeft: true,
    leftTimes: 6,
    rightTimes: 6,
  },
  {
    actionId: 14,
    isLeft: false,
    leftTimes: 7,
    rightTimes: 6,
  },
];

export const ShoulderLvActionId2Times = [
  {
    actionId: 9,
    isLeft: true,
    leftTimes: 0,
    rightTimes: 0,
  },
  {
    actionId: 10,
    isLeft: false,
    leftTimes: 1,
    rightTimes: 0,
  },
  {
    actionId: 11,
    isLeft: true,
    leftTimes: 1,
    rightTimes: 1,
  },
  {
    actionId: 12,
    isLeft: false,
    leftTimes: 2,
    rightTimes: 1,
  },
  {
    actionId: 13,
    isLeft: true,
    leftTimes: 2,
    rightTimes: 2,
  },
  {
    actionId: 14,
    isLeft: false,
    leftTimes: 3,
    rightTimes: 2,
  },
  {
    actionId: 15,
    isLeft: true,
    leftTimes: 3,
    rightTimes: 3,
  },
  {
    actionId: 16,
    isLeft: false,
    leftTimes: 4,
    rightTimes: 3,
  },
];

export const allAbdomenMoxInfo: any = [
  {
    name: 'image6',
    type: 'image',
    imageConfig: {
      url: storagePrefix + '/model-texture/matrix-mox-abdomen-1.png',
      size: [450, 230],
    },
    coord: [320, 700],
  },
  {
    name: 'image7',
    type: 'image',
    imageConfig: {
      url: storagePrefix + '/model-texture/matrix-mox-abdomen-2.png',
      size: [450, 230],
    },
    coord: [320, 800],
  },
];

export const BUFFET_PLAN_STEP_2_TIPS = {
  1: {
    name: '左大杼',
    tip: '疏通膀胱经，促进气血运行，达到强筋壮骨的目的',
  },
  2: {
    name: '左肩外俞',
    tip: '缓解肩背疼痛、促进上肢气血运行、改善颈项僵硬等症状',
  },
  3: {
    name: '左肩井',
    tip: '放松肌肉、促进头部气血循环，缓解压力、放松身心',
  },
  4: {
    name: '右大杼',
    tip: '疏通膀胱经，促进气血运行，达到强筋壮骨的目的',
  },
  5: {
    name: '右肩外俞',
    tip: '缓解肩背疼痛、促进上肢气血运行、改善颈项僵硬等症状',
  },
  6: {
    name: '右肩井',
    tip: '放松肌肉、促进头部气血循环，缓解压力、放松身心',
  },
  7: {
    name: '左大杼',
    tip: '疏通膀胱经，促进气血运行，达到强筋壮骨的目的',
  },
  8: {
    name: '右大杼',
    tip: '疏通膀胱经，促进气血运行，达到强筋壮骨的目的',
  },
};

export const SOLUTION_TO_MASSAGE_POINT: Partial<Record<Massage.ModelSolution, { coord: number[] }[]>> = {
  'massage-shoulder-lv': ShoulderLvMassagePointConfigV2,
  'massage-shoulder-lv-v2': ShoulderLvMassagePointConfigV2Optimize,
  'massage-waist-lv': WaistLvMassagePointConfig,
  'massage-yzc': FullMassagePointConfig,
  'massage-yzc-zhai': MassageZhaiPointsConfig,
  'massage-yzc-10-points': FullMassagePointConfigWith10Point,
};
